var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes('speech-button-container'),on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{class:_vm.classes('label')},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }